import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import { AuthProvider } from './contexts/AuthContext';
import ChatPage from './components/ChatPage';
import { ChatProvider } from './contexts/ChatContext';
import ProfileSettings from './components/ProfileSettings'; // Import the new component

function App() {
  return (
    <Router>
      <AuthProvider>
        <ChatProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/profile" element={<ProfileSettings />} /> {/* Add the new route */}
          </Routes>
        </ChatProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
